(function ($, Drupal, once) {
  Drupal.behaviors.dNRW = {
    attach: function (context, settings) {
      once('goto-faq', 'button.goto-faq', context).forEach(function (button) {
        button.addEventListener('click', function () {
          const homeTab = document.getElementById('home-tab');
          const faqAnchor = document.getElementById('faq-anchor');

          if (homeTab) {
            homeTab.click();
          }

          // Kurz warten, bis das Tab-Panel sichtbar ist (Bootstrap fade)
          setTimeout(function () {
            if (faqAnchor) {
              faqAnchor.scrollIntoView({ behavior: 'smooth' });
            }
          }, 300);
        });
      });
    }
  };
})(jQuery, Drupal, once);
